import { PropertyTable } from '@/components/property-table';
import { AddPropertyButton } from '@/components/add-property-button';
import { usePermissions } from '@/hooks/use-permissions';

export function LandMonitoringProperties() {
  const { role } = usePermissions();
  const isAdmin = role === 'admin';

  return (
    <section id="land-monitoring" className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <h1 className="font-display text-3xl font-medium tracking-tight text-foreground">
          Land Monitoring
        </h1>
        <AddPropertyButton />
      </div>
      <PropertyTable adminView={isAdmin} />
    </section>
  );
}
